import { render, staticRenderFns } from "./commission-details-table.vue?vue&type=template&id=a01cce30"
import script from "./commission-details-table.vue?vue&type=script&lang=ts"
export * from "./commission-details-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports